import { render } from "./UserLoginHistory.vue?vue&type=template&id=6f5cdd60&scoped=true"
import script from "./UserLoginHistory.vue?vue&type=script&lang=js"
export * from "./UserLoginHistory.vue?vue&type=script&lang=js"

import "./UserLoginHistory.vue?vue&type=style&index=0&id=6f5cdd60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5cdd60"]])

export default __exports__